export default __webpack_public_path__ + "static/media/Protocol-Deaveation.a8771619.svg";